import Carrossel from "./components/Carrossel";
import { NavLink } from "react-router-dom";
import ProdutosProducao from "./ProdutosProducao";
import banner from '../img/banner.png';
import AuthContext from "../servicos/autorizacao/AuthContex";
import { useContext, useEffect, useState } from "react";
import servicosColaborador from "../servicos/servicos-colaborador";

const SolicitacoesExterna = () => {
    const { user,  } = useContext(AuthContext);
    const [pontucaoExterna, setPontuacaoExterna] = useState([]);
    const nomeCompleto = String(user.nome).split(' ');
    const nome = nomeCompleto[0];
    const sobrenome = nomeCompleto[nomeCompleto.length - 1];
    const [carrinho, setCarrinho] = useState([]);
  
    useEffect(() => {
        let carrinhoJSON = localStorage.getItem('carrinho_producao');
        let carrinho = JSON.parse(carrinhoJSON);
        setCarrinho(carrinho);
    }, []);

    useEffect(() => {
        servicosColaborador.getTotalPontosExternos(user.id).then(response => {
            if (response.status === 200) {
                setPontuacaoExterna(response.data);
            }
        }).catch(e => console.log(e))
    }, [user.id]);

   
    return <>

        <div className=" container mt-3">
            <div className="d-flex row justify-container-center align-items-center">
                <a style={{ fontSize: 22, width: 250 }} className="subtitulo" href="/">Ir p/ área pessoal</a>

                <div className="d-flex align-items-center container banner-producao mt-5 mb-2">
                    <div className="w-50 d-flex justify-content-center p-5">
                        <img src={banner} width='50%' alt='mulher sorrindo com algumas bolsas na mão com os braços para o alto' />
                    </div>
                    <div className="w-50 h-50 d-flex justify-content-center texto-banner row  align-items-center">
                        <h1 className="text-center text-light ">Lev Milhas</h1>
                        <h3 className="text-center text-light" >Você está na área comercial. Milhas e produtos exclusivos p/ presentear seus parceiros.</h3>
                        <a className="text-center btn-login w-25 mt-3 text-light rounded-4" href="/ShoppingProducao">Produtos p/ parceiros</a>
                        <div className="text-center  icons-banner">
                            <div className="text-light d-flex justify-content-between align-items-center mt-5">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" className="bi bi-person-video" viewBox="0 0 16 16">
                                        <path d="M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
                                        <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2Zm10.798 11c-.453-1.27-1.76-3-4.798-3-3.037 0-4.345 1.73-4.798 3H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1.202Z" />
                                    </svg>
                                    <span className="ms-2 me-3">{nome} {sobrenome} </span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" className="bi bi-coin" viewBox="0 0 16 16">
                                        <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z" />
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z" />
                                    </svg>
                                    <span className="ms-2">{String(pontucaoExterna.pontosAtivos)} milhas produção</span>
                                </div>
                                <div className="ms-4">
                                    <a href="/Carrinho">

                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" className="bi bi-cart-check-fill ms-3" viewBox="0 0 16 16">
                                            <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708z" />
                                        </svg>{carrinho?.produtos?.length > 0 && <span style={{ marginTop: 20, color: '#FF6900', fontSize: 11 }}>{carrinho?.produtos?.length}</span>} <span className="text-light">produção</span>
                                    </a>

                                </div>
                            </div>
                            <div className="d-flex row justify-content-center mt-3">
                                <NavLink className="ms-1 btn-banner border w-50 rounded-5 mt-1" style={{ color: '#FF6900' }} to="/HistoricoExterno">Histórico de Milhas Prod.</NavLink>
                                <NavLink className="ms-1 btn-banner border w-50 rounded-5 mt-1" style={{ color: '#FF6900' }} to="/MinhasSolicitacoesExternas">Minhas Solicitações</NavLink>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="container">
                <Carrossel />
            </div>
            <div className="mt-5 ">
                <div className="my-5">
                    <h3 className="subtitulo text-center">Produtos Para Solicitação de Produção</h3>
                </div>
                <ProdutosProducao menu='false' />
            </div>
        </div>

    </>
}

export default SolicitacoesExterna;